import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DropdownSelect from '../../../ui/dropdown';
import { session } from '../../../../services/session';
import { api } from '../../../../services/api';

const PublisherDropdown = props => {
  const { selected, onSelect, confirmPrompt } = props;

  const [pubOptions, setPubOptions] = useState([]);

  useEffect(() => {
    const fetchPubList = async () => {
      const pubListEndpoint = `/api/v0/merchants/${session.orgId}/strategy/type_ahead/`;
      const resp = await api.get(pubListEndpoint, { type: 'publisher' });

      return resp;
    };

    fetchPubList().then(resp => {
      const pubList = resp.data.data[0].stats.sort((pub1, pub2) => {
        return pub1.full_name.toLowerCase() > pub2.full_name.toLowerCase() ? 1 : -1;
      });
      const formattedPubList = pubList.map(pub => ({ label: pub.full_name, value: pub.pub_id }));

      setPubOptions(formattedPubList);
    });
  }, []);

  const label =
    selected.length === 0
      ? 'Publisher'
      : selected.length > 1
      ? `${selected.length} Publishers`
      : selected[0].label;

  return (
    <DropdownSelect
      items={pubOptions}
      selected={selected}
      onSelect={onSelect}
      label={label}
      multi={true}
      searchable={true}
      confirmPrompt={confirmPrompt}
    />
  );
};

PublisherDropdown.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  confirmPrompt: PropTypes.bool,
};

PublisherDropdown.defaultProps = {
  selected: [],
  onSelect: () => {},
  confirmPrompt: true,
};

export default PublisherDropdown;
